import SectionHeading from "@/components/base/SectionHeading";
import { solutions } from "@/mocks/home";

export default function Solutions() {
  return (
    <section id="solutions" className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Our answer"
            title={
              <>
                A compact, modular
                <br className="hidden md:block" /> route to green steel
              </>
            }
            description="One 30-acre site runs the whole chain — renewable power makes green hydrogen, hydrogen turns iron ore into DRI, and the hot iron is pressed into HBI for any steel plant."
          />
          <a
            href="#process"
            className="reveal inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            How it works
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {solutions.map((solution, index) => (
            <article
              key={solution.title}
              className="reveal group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              style={{ transitionDelay: `${index * 70}ms` }}
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={solution.image}
                  alt={solution.title}
                  title={`${solution.title} green steel solution`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-700">
                  <i className={`${solution.icon} text-xl`} />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{solution.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{solution.description}</p>
                <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                  {solution.points.map((point) => (
                    <li key={point} className="flex items-center gap-2 text-xs text-foreground-700">
                      <i className="ri-check-double-line text-primary-600" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}